import React, { useState } from "react";
import moment from "moment";
import { StripeSubscription } from "../../components/stripeSubscription";
import { StripePayment } from "../../components/stripePayment";
import admin, { stripeKey } from "../../common/firebase";
import { getEndDate, getPlan, getPlanPrice } from "../../common/plans";
import { listOfSubscriptions, plansEnvConfig } from "../../common/envConfig";
import { IoArrowBackOutline } from "react-icons/io5";
import ProratedInfo from "../account_details/components/WarningModal/ProratedInfo";
import Divider from "../../components/shared/Divider/Divider";
import { userService } from "../../services/user";
import { useMemo } from "react";
import { stripeService } from "../../components/stripeSubscription/services/stripe";
import { toast } from "react-toastify";
import { useAuthUser } from "../../hooks/useAuthUser";
import Spinner from "../../components/shared/spinner/Spinner";
import { useEffect } from "react";
import {
  discountedPrice,
  planProrationEligibility,
} from "../../components/stripeSubscription/utils/discountedPrice";

function PlansPaymentComponent({
  productId,
  bootcampUser,
  freeTrial,
  email,
  uid,
  finish,
  back,
  subData,
  fullName,
  addOn,
}) {
  const [isLoading, setIsLoading] = useState(false);
  const [price, setPrice] = useState(
    bootcampUser
      ? "400"
      : addOn
      ? getPlanPrice(productId) + (productId.includes("monthly") ? 40 : 400)
      : getPlanPrice(productId)
  );

  const { user } = useAuthUser();

  useEffect(() => {
    console.log(price);
  }, [price]);

  useEffect(() => {
    if (!subData?.productId || !productId) return;
    //  const oldProductId =
    //   subData?.oldSubscription?.productId || subData?.productId;
    const oldProductId = subData?.productId;
    if (!plansEnvConfig[oldProductId] || !plansEnvConfig[productId]) return;
    if (planProrationEligibility(oldProductId, productId)) {
      const previousPlanPriceCents = plansEnvConfig[oldProductId] * 100;
      const newPlanPriceCents = plansEnvConfig[productId] * 100;

      const remainingCreditCents = discountedPrice({
        previousSubStartDate: subData?.startDate,
        previousSubEndDate: subData?.endDate,
        planPriceCents: previousPlanPriceCents,
      });

      const proratedCents = Math.max(
        newPlanPriceCents - remainingCreditCents,
        0
      );
      const proratedPrice = (proratedCents / 100).toFixed(2);

      setPrice(proratedPrice);
    }
  }, [subData, productId]);

  const createSubscription = async (data) => {
    if (!user || !user.uid || !email) {
      toast.error("User not authenticated. Please log in.");
      console.log(
        "[createSubscription] toast.error called: User not authenticated"
      );
      return;
    }
    if (!productId) {
      toast.error("No plan selected. Please choose a plan before proceeding.");
      console.log("[createSubscription] toast.error called: No plan selected");
      return;
    }
    setIsLoading(true);
    console.log("[createSubscription] setIsLoading(true) called");

    // grab referral code from URL
    const params = new URLSearchParams(window.location.search);
    const referralCode = params.get("REFERRALCODE")?.toUpperCase() ?? "";
    console.log("[createSubscription] referralCode:", referralCode);
    try {
      if (bootcampUser) {
        const userData = await userService.getUserData(uid);
        console.log(
          "[createSubscription] userService.getUserData returned:",
          userData
        );

        // 1️⃣ Fetch & flag the userData as a bootcampUser
        const setUserDataRes = await userService.setUserData({
          uid: userData.uid,
          userInfo: { bootcampUser },
        });
        console.log(
          "[createSubscription] userService.setUserData returned:",
          setUserDataRes
        );

        // 2️⃣ Create a Stripe subscription with a 61-day free trial
        const stripeSubRes = await stripeService.setStripeSubscription({
          email: email,
          freeTrial: 61,
          productId: productId,
        });
        console.log(
          "[createSubscription] stripeService.setStripeSubscription returned:",
          stripeSubRes
        );
        const { subscription } = stripeSubRes;

        // 3️⃣ Create Teachble account & send notification email
        const teachableRes = await userService.setBootcampTeachableUser({
          email: email,
          uid: userData.uid,
          name: userData
            ? userData.firstName + " " + userData.lastName
            : "3D Golfer",
        });
        console.log(
          "[createSubscription] userService.setBootcampTeachableUser returned:",
          teachableRes
        );

        const bootcampEmailRes = await userService.sendBootcampEmail({
          bootcampUser,
          email: email,
          uid: userData.uid,
        });
        console.log(
          "[createSubscription] userService.sendBootcampEmail returned:",
          bootcampEmailRes
        );

        // 4️⃣ Pause the Stripe subscription immediately
        const pauseSubRes = await userService.pauseStripeSubByID(
          subscription.id
        );
        console.log(
          "[createSubscription] userService.pauseStripeSubByID returned:",
          pauseSubRes
        );

        // 5️⃣ Record it in your backend
        const createSubRes = await userService.createSubscription({
          amount: data.amount > 1500 ? data.amount / 100 : data.amount,
          autoRenewal: false,
          bootcampUser,
          endDate: moment().add(2, "M").valueOf().toString(),
          lastUpdated: Date.now().toString(),
          orderId: "",
          packageId: "",
          payload: "",
          plan: productId,
          planDescription: "",
          planType: productId.includes("monthly") ? "monthly" : "annually",
          platform: "Stripe",
          productId: productId,
          referralCode,
          startDate: Date.now().toString(),
          transactionId: subscription.id,
          userId: userData.uid,
        });
        console.log(
          "[createSubscription] userService.createSubscription returned:",
          createSubRes
        );

        toast.success("Your bootcamp subscription has been created!");
        console.log(
          "[createSubscription] toast.success called: Bootcamp subscription created"
        );
        finish();
        console.log("[createSubscription] finish() called");
      } else {
        // 1️⃣ Record the main subscription
        const createSubRes = await userService.createSubscription({
          amount: data.amount / 100,
          autoRenewal: true,
          bootcampUser,
          endDate: getEndDate(productId),
          lastUpdated: Date.now().toString(),
          orderId: "",
          packageId: "",
          payload: "",
          plan: productId,
          planDescription: "",
          planType: productId.includes("monthly") ? "monthly" : "annually",
          platform: "Stripe",
          productId: productId,
          referralCode,
          startDate: Date.now().toString(),
          transactionId: data.id,
          userId: user.uid,
        });
        console.log(
          "[createSubscription] userService.createSubscription returned:",
          createSubRes
        );

        // 2️⃣ If an add-on is selected, record that too
        if (addOn) {
          const partnerPlanId = productId.includes("monthly")
            ? listOfSubscriptions.FORESIGHT_MONTHLY
            : listOfSubscriptions.FORESIGHT_ANNUALLY;
          const partnerAmount = productId.includes("monthly") ? 40 : 400;

          const createPartnerSubRes =
            await userService.createPartnerSubscription({
              amount: partnerAmount,
              autoRenewal: true,
              endDate: productId.includes("monthly")
                ? moment().add(1, "M").valueOf().toString()
                : moment().add(1, "y").valueOf().toString(),
              isAddOn: false,
              lastUpdated: Date.now().toString(),
              plan: partnerPlanId,
              planType: productId.includes("monthly") ? "monthly" : "annually",
              platform: "Stripe",
              productId: partnerPlanId,
              promoCode: "",
              startDate: Date.now().toString(),
              transactionId: data.id,
              userEmail: email,
              userId: user.uid,
              userName: fullName,
            });
          console.log(
            "[createSubscription] userService.createPartnerSubscription returned:",
            createPartnerSubRes
          );
        }
        await userService.updateProratedStripeSubscriptionToNormalPriceOnNextBilling(
          { userEmail: email.toLowerCase().trim() }
        );
        toast.success("Your subscription has been created!");
        console.log(
          "[createSubscription] toast.success called: Subscription created"
        );
        finish();
        console.log("[createSubscription] finish() called");

        // 3️⃣ Record any referral
        if (referralCode) {
          const setUserReferralRes = await userService.setUserReferral({
            amount: data.amount / 100,
            email: email.toLowerCase().trim(),
            externalIdentifier: data.id,
            firstName: fullName.split(" ")[0].replace(/ /g, ""),
            lastName: fullName.split(" ")[0].replace(/ /g, ""),
            note: productId,
            referralCode,
          });
          console.log(
            "[createSubscription] userService.setUserReferral returned:",
            setUserReferralRes
          );
        }
      }
    } catch (err) {
      console.error("createSubscription error", err);
      console.log("[createSubscription] Error:", err);
      toast.error(
        err.message ||
          "There was an error processing your subscription, please try again."
      );
      console.log("[createSubscription] toast.error called for error");
    } finally {
      setIsLoading(false);
      console.log("[createSubscription] setIsLoading(false) called");
    }
  };

  // const isUpgrade = planProrationEligibility(
  //   subData?.oldSubscription?.productId || subData?.productId,
  //   productId
  // );

  const isUpgrade = planProrationEligibility(subData?.productId, productId);

  return (
    <div className="p-6 rounded-xl border border-gray200 shadow-[0_1px_3px_0_rgba(14,24,41,0.10),_0_1px_2px_0_rgba(14,24,41,0.06)]">
      <div className="flex flex-row items-center gap-2">
        <IoArrowBackOutline
          className="size-5 min-w-5 text-gray600"
          onClick={() => back()}
        />

        <div className="text-gray600 text-sm font-semibold">Back to plans</div>
      </div>

      <div className="mt-2 font-semibold text-xl text-gray900">
        {bootcampUser
          ? "Bootcamp"
          : getPlan(productId) + (addOn ? " + Foresight" : "")}
      </div>

      {isUpgrade && (
        <div className="mt-6">
          <ProratedInfo subscriptionData={subData} selectedPlan={productId} />
        </div>
      )}

      <Divider className="my-6" color="gray200" type="horizontal"/>

      {!bootcampUser && freeTrial && !productId.includes("free") && (
        <div className="text-base text-gray600">
          You will not be charged until your free trial ends on{" "}
          {moment().add(14, "d").format("MM/DD/YYYY")}.
        </div>
      )}
      {!freeTrial && (
        <>
          <div className="flex flex-row items-center gap-2">
            {isUpgrade && (
              <div className="font-semibold text-xl text-pink700 line-through">
                ${plansEnvConfig[productId]}
              </div>
            )}
            <div className="font-semibold text-xl text-black">${price}</div>
          </div>
          <div className="text-black text-sm font-bold mt-2">Total</div>
        </>
      )}

      <Divider className="my-6" color="gray200" type="horizontal"/>

      {isLoading ? (
        <div className="flex justify-center py-12">
          <Spinner color="primary500" size="md" />
        </div>
      ) : bootcampUser ? (
        <div className="mt-6">
          <StripePayment
            amount={400}
            handleResult={createSubscription}
            email={email}
            buttonText="Subscribe"
            hideSavedCard={true}
          />
        </div>
      ) : (
        <div className="mt-6">
          <StripeSubscription
            email={email}
            productId={productId}
            handleResult={createSubscription}
            freeTrial={
              productId?.includes("free") ||
              subData?.freeTrialUsed ||
              !freeTrial
                ? 0
                : 14
            }
            showDetails={false}
            fullName={fullName}
            handlePrice={setPrice}
            addOn={addOn}
          />
        </div>
      )}
    </div>
  );
}

export default PlansPaymentComponent;
